import React from "react";
import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Poland from "./pages/Poland";

function App() {
  return (
<Router>
      <Routes>
        <Route exact path="/" Component={Home} />
        <Route exact path="/services" Component={Services} />
        <Route exact path="/aboutus" Component={About} />
        <Route exact path="/poland" Component={Poland} />
      </Routes>
    </Router>
  );
}

export default App;
